import Vue from 'vue';
import $ from 'jquery';
import moment from 'moment';
import VueI18n from 'vue-i18n';
import VModal from 'vue-js-modal';
import Toasted from 'vue-toasted';
import VueConfirmDialog from 'vue-confirm-dialog';
import VTooltip from 'v-tooltip';
import ToggleButton from 'vue-js-toggle-button';

import App from './App.vue';
import store from './store';
import router from './router';
import { auth } from './firebase';
import mixin from './mixins/mixin';

// My css
import './assets/scss/app.scss';

// Package css
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

const langFr = require('./locales/lang-fr.json');
const langEn = require('./locales/lang-en.json');

moment.locale('fr', {
  months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
    '_'
  ),
  monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
    '_'
  ),
  monthsParseExact: true,
  weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
  weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
  weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
  },
  calendar: {
    sameDay: '[Aujourd’hui à] LT',
    nextDay: '[Demain à] LT',
    nextWeek: 'dddd [à] LT',
    lastDay: '[Hier à] LT',
    lastWeek: 'dddd [dernier à] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'dans %s',
    past: 'il y a %s',
    s: 'quelques secondes',
    m: 'une minute',
    mm: '%d minutes',
    h: 'une heure',
    hh: '%d heures',
    d: 'un jour',
    dd: '%d jours',
    M: 'un mois',
    MM: '%d mois',
    y: 'un an',
    yy: '%d ans',
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal(number) {
    return number + (number === 1 ? 'er' : 'e');
  },
  meridiemParse: /PD|MD/,
  isPM(input) {
    return input.charAt(0) === 'M';
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem(hours) {
    return hours < 12 ? 'PD' : 'MD';
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // Used to determine first week of the year.
  },
});

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$', { value: $ });
Vue.use(VModal);
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000,
  iconPack: 'fontawesome',
  theme: 'bubble',
  type: 'success',
});

Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

const tooltipOptions = {};
Vue.use(VTooltip, tooltipOptions);

Vue.use(VueI18n);
const messages = {
  fr: langFr,
  en: langEn,
};
const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages,
});

Vue.use(ToggleButton);

Vue.mixin(mixin);

let app;
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  }
  if (user) {
    store.dispatch('fetchUserProfile', user);
  }
});
